<script>
import './stylesheets/components/VsTabs';

import VsLayout from './VsLayout';

export default {
  components: {
    VsLayout,
  },
  props: {
    tabs: Array,
    activeTab: String,
    large: [String, Boolean],
    showBorder: [String, Boolean],
    disabled: [String, Boolean],
    padding: String,
    ariaBaseId: String,
  },
  methods: {
    handleClick(tab) {
      if (!this.disabled) this.$emit('change-tab', typeof tab === 'object' ? tab.value : tab)
    },
    classes(tab) {
      return {
        'vs-tab--active': this.isSelected(tab),
        'vs-tab--disabled': this.disabled,
        'vs-tab--large': this.large,
      };
    },
    getAriaTabIdFromBase(index) {
      return this.ariaBaseId ? `${this.ariaBaseId}_${index}` : null; 
    },
    isSelected(tab) {
      return typeof tab === 'object' ? tab.value === this.activeTab : tab === this.activeTab;
    },
  },
};
</script>

<template lang='pug'>
vs-layout.vs-tabs(
  wrap-xs,
  horz-align-center-xs,
  role='tablist',
  :class='{ "vs-tabs--border": showBorder, "vs-tabs--padding": padding }',
)
  vs-layout.vs-tab(
    v-for='(tab, index) in tabs',
    :id='getAriaTabIdFromBase(index)',
    auto-xs,
    no-gutter,
    horz-align-center-xs,
    vert-align-center-xs,
    tabindex='0',
    role='tab',
    :aria-selected='isSelected(tab)',
    :class='classes(tab)',
    :key='tab.text',
    @click.native='handleClick(tab)',
    @keyup.enter.native='handleClick(tab)',
  )
    span {{typeof tab === "object" ? tab.text : tab}}
</template>